import { useViewport } from 'contexts/viewport';
import { DesktopForm, DesktopLoading, DesktopResult } from 'pages/CreateRubricExisting/desktop';
import { MobileForm, MobileLoading, MobileResult } from 'pages/CreateRubricExisting/mobile';
import { PageContext } from 'pages/CreateRubricExisting/PageProvider';
import { TabletForm, TabletLoading, TabletResult } from 'pages/CreateRubricExisting/tablet';
import { useContext } from 'react';

const PageLayout = () => {
    const { device } = useViewport();

    const {
        tab,
        setTab,
        files,
        setFiles,
        error,
        setError,
        value,
        setValue,

        isLoading,
        onClickBack,

        result,
        setResult,
        rubricErrors,
        setRubricErrors,
        hasClickedSubmitRubric,
        setHasClickedSubmitRubric,
        validateTitle,
        validateCriteria,
        onClickEditSettings,
    } = useContext(PageContext);

    const formProps = {
        tab,
        setTab,
        files,
        setFiles,
        error,
        setError,
        value,
        setValue,
    };

    const loadingProps = {
        isLoading,
        onClickBack,
    };

    const resultProps = {
        result,
        setResult,
        rubricErrors,
        setRubricErrors,
        hasClickedSubmitRubric,
        setHasClickedSubmitRubric,
        validateTitle,
        validateCriteria,
        onClickEditSettings,
    };

    const renderForm = (device) => {
        return {
            mobile: <MobileForm {...formProps} />,
            tablet: <TabletForm {...formProps} />,
            desktop: <DesktopForm {...formProps} />,
        }[device];
    };

    const renderLoading = (device) => {
        return {
            mobile: <MobileLoading {...loadingProps} />,
            tablet: <TabletLoading {...loadingProps} />,
            desktop: <DesktopLoading {...loadingProps} />,
        }[device];
    };

    const renderResult = (device) => {
        return {
            mobile: <MobileResult {...resultProps} />,
            tablet: <TabletResult {...resultProps} />,
            desktop: <DesktopResult {...resultProps} />,
        }[device];
    };

    if (isLoading) return renderLoading(device);
    if (result) return renderResult(device);
    return renderForm(device);
};

export default PageLayout;
